import { Chip } from 'external/material'

import useCatalog from 'hooks/catalog'

export default function SubjectChip (props) {
  const {subjects = {}} = useCatalog()
  const {color: backgroundColor, textColor: color, name} = subjects[props.course.substring(0, 2)] || {}
  return (<Chip className="subjectChip" label={name} sx={{backgroundColor, color, width: 130, fontSize: '9pt'}} />)
}
